(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["background-video"] && !Shopify.designMode) return;
  try {
    
  // Scroll-autoplay: play when ~40% in view, pause out of view; reveal animation class.
  (function () {
    function init() {
      var wraps = document.querySelectorAll('[data-pr-video-wrap]');
      if (!wraps.length || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var vid = e.target.querySelector('video[data-scroll-video]');
          if (!vid) return;
          if (e.isIntersecting) {
            e.target.classList.add('is-inview');
            var p = vid.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            e.target.classList.remove('is-inview');
            vid.pause();
          }
        });
      }, { threshold: 0.4 });
      wraps.forEach(function (w) { io.observe(w); });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.initAnimateOnScroll();
      initYmlGrid(productRecommendationsSection);
    }
  };
  request.send();
};

// Long Represent-style grid: tabs (Suggested / collections) + infinite append
// from the yml-more feeder as the shopper scrolls.
function initYmlGrid(root) {
  var grid = root.querySelector('[data-yml-grid]');
  var sentinel = root.querySelector('[data-yml-sentinel]');
  if (!grid || grid.dataset.ymlReady) return;
  grid.dataset.ymlReady = '1';

  var state = { tab: '__suggested', page: 0, totalPages: 99, loading: false, done: false, seen: {} };
  grid.querySelectorAll('[data-product-id]').forEach(function (el) { state.seen[el.getAttribute('data-product-id')] = true; });

  function feederUrl() {
    var base = state.tab === '__suggested' ? '/collections/all' : '/collections/' + state.tab;
    return base + '?section_id=yml-more&sort_by=best-selling&page=' + state.page;
  }
  function loadMore() {
    if (state.loading || state.done) return;
    state.loading = true;
    state.page += 1;
    if (state.page > state.totalPages) { state.done = true; state.loading = false; return; }
    fetch(feederUrl())
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var pageEl = doc.querySelector('[data-yml-more-page]');
        if (!pageEl) { state.done = true; return; }
        state.totalPages = parseInt(pageEl.getAttribute('data-total-pages'), 10) || state.page;
        pageEl.querySelectorAll('.rep-card').forEach(function (card) {
          var id = card.getAttribute('data-product-id');
          if (id && state.seen[id]) return;
          if (id) state.seen[id] = true;
          grid.appendChild(card);
        });
        if (state.page >= state.totalPages) state.done = true;
      })
      .catch(function () { state.done = true; })
      .finally(function () {
        state.loading = false;
        setTimeout(ensureMin, 100);
      });
  }

  // First impression: always show at least 6 cards (3 mobile rows) — Shopify
  // recommendations alone can return as few as 1-2. The scroll sentinel keeps
  // feeding more as the shopper digs.
  function ensureMin() {
    if (state.done || state.loading) return;
    if (grid.children.length < 6) loadMore();
  }

  root.querySelectorAll('[data-yml-tab]').forEach(function (tab) {
    tab.addEventListener('click', function () {
      if (tab.dataset.ymlTab === state.tab) return;
      root.querySelectorAll('[data-yml-tab]').forEach(function (t) { t.classList.remove('is-active'); });
      tab.classList.add('is-active');
      state.tab = tab.dataset.ymlTab;
      state.page = 0; state.totalPages = 99; state.done = false; state.seen = {};
      grid.innerHTML = '';
      loadMore();
    });
  });

  ensureMin();

  if ('IntersectionObserver' in window && sentinel) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) loadMore(); });
    }, { rootMargin: '600px 0px' }).observe(sentinel);
  }
}

document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  // Scroll-autoplay: play when ~40% in view, pause out of view; reveal class.
  // Only the clip on screen plays. A clip that leaves the screen is paused at once and, if it is still
  // off screen 1.5 s later, unloaded (src removed) so it holds no decoder and downloads nothing; it
  // comes back at the same second when it scrolls in again (the CDN file is cached for a year, so the
  // second load is local). The 720p file is for screens from 1024 px up; everything narrower, and
  // anyone with data saver on, gets the 480p one.
  (function () {
    function pick(vid) {
      var small = window.matchMedia('(max-width: 1023px)').matches || (navigator.connection && navigator.connection.saveData);
      return small ? vid.getAttribute('data-src-sd') : vid.getAttribute('data-src-hd');
    }
    function attach(vid) {
      var src = pick(vid);
      if (!src) return;
      var at = parseFloat(vid.getAttribute('data-resume') || '0') || 0;
      vid.src = src;
      vid.load();
      if (at > 0) {
        var seek = function () { try { vid.currentTime = at; } catch (err) {} };
        if (vid.readyState >= 1) seek(); else vid.addEventListener('loadedmetadata', seek, { once: true });
      }
    }
    function play(vid) {
      var p = vid.play();
      if (p && p.catch) p.catch(function () {});
    }
    function init() {
      var wraps = document.querySelectorAll('[data-pr-video-wrap]');
      if (!wraps.length || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var vid = e.target.querySelector('video[data-scroll-video]');
          if (!vid) return;
          if (e.isIntersecting) {
            e.target.classList.add('is-inview');
            clearTimeout(vid._prUnload);
            if (!vid.getAttribute('src')) attach(vid);
            play(vid);
          } else {
            e.target.classList.remove('is-inview');
            vid.pause();
            clearTimeout(vid._prUnload);
            vid._prUnload = setTimeout(function () {
              if (e.target.classList.contains('is-inview') || !vid.getAttribute('src')) return;
              vid.setAttribute('data-resume', String(vid.currentTime || 0));
              vid.removeAttribute('src');
              vid.load();
            }, 1500);
          }
        });
      }, { threshold: 0.4 });
      wraps.forEach(function (w) { io.observe(w); });
      /* a hidden tab decodes nothing; back on screen, the clip in view resumes */
      document.addEventListener('visibilitychange', function () {
        wraps.forEach(function (w) {
          var vid = w.querySelector('video[data-scroll-video]');
          if (!vid || !vid.getAttribute('src')) return;
          if (document.hidden) vid.pause();
          else if (w.classList.contains('is-inview')) play(vid);
        });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  } catch(e) { console.error(e); }
})();
})();
